import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Message, Segment, Button, Form } from 'semantic-ui-react'
import { firebaseConnect } from 'react-redux-firebase'
import { Field, reduxForm } from 'redux-form'
import styled from 'styled-components'
import { getAuthError, getHumanReadableAuthErrorCode } from 'store/selectors'
import { UserIsNotAuthenticated } from 'utils/RouteGuards'
import logo from 'assets/logo.jpg'

import { SemanticFormField } from 'components'

const Wrapper = styled.div`
  height: 100%;
`
const InnerWrapper = styled.div`
  max-width: 450px;
`
const Logo = styled.h2`
  margin-top: -100px !important;
`

@UserIsNotAuthenticated
@reduxForm({
  form: 'login'
})
@firebaseConnect() // add this.props.firebase
@connect(
  // map redux state to props
  state => ({
    authError: getAuthError(state),
    authErrorCode: getHumanReadableAuthErrorCode(state)
  })
)
export default class Login extends Component {
  static propTypes = {
    firebase: PropTypes.shape({
      login: PropTypes.func.isRequired
    }),
    handleSubmit: PropTypes.func.isRequired,
    authError: PropTypes.shape({
      code: PropTypes.string,
      message: PropTypes.string
    }),
    authErrorCode: PropTypes.string
  }

  state = {
    isLoading: false
  }

  login = async credentials => {
    this.setState({ isLoading: true })
    try {
      await this.props.firebase.login(credentials)
      this.setState({ isLoading: false })
    } catch (error) {
      this.setState({ isLoading: false })
    }
  }

  render () {
    const { handleSubmit, authError, authErrorCode } = this.props
    const { isLoading } = this.state
    const hasAuthError = !!authError

    return (
      <Wrapper className='ui middle aligned center aligned grid'>
        <InnerWrapper className='column'>
          <Logo className='ui red image header'>
            <img src={logo} className='image' />
            <div className='content'>In den Account einloggen</div>
          </Logo>
          <Form
            loading={isLoading}
            error={hasAuthError}
            size='large'
            name='login'
            onSubmit={handleSubmit(this.login)}
          >
            <Segment stacked secondary>
              <Field
                name='email'
                component={SemanticFormField}
                as={Form.Input}
                type='email'
                placeholder='E-Mail'
                icon='user'
                iconPosition='left'
                required
              />

              <Field
                name='password'
                component={SemanticFormField}
                as={Form.Input}
                type='password'
                placeholder='Passwort'
                icon='lock'
                iconPosition='left'
                required
              />

              <Button fluid size='large' primary type='submit'>
                Einloggen
              </Button>
              <Message
                error
                header={hasAuthError && authErrorCode}
                content={hasAuthError && authError.message}
              />
            </Segment>
          </Form>
        </InnerWrapper>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Login/index.js